import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";
import { InfluencerDiscovery } from "./components/influencer-card/influencer-discovery";

/**
 * Mounts the influencer discovery surfaces (T212648 dashboard module, T212649 profile
 * section). Both are emitted by the same view component, so both land on the same class and
 * the `variant` in the initial props decides which shape renders.
 *
 * querySelectorAll rather than getElementById: a page may legitimately carry more than one
 * (the profile shows the section, and nothing stops a dashboard block appearing alongside).
 */
function InfluencerDiscoveryRenderer() {
  const elements = document.querySelectorAll(".react-influencer-discovery");

  elements.forEach((element) => {
    let initialProps = null;

    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(error, "Could not parse initial props JSON for InfluencerDiscovery");
      return;
    }

    if (!initialProps) {
      return;
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <InfluencerDiscovery {...initialProps} />
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initInfluencerDiscovery = () => {
  if (document.readyState !== "loading") {
    InfluencerDiscoveryRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", InfluencerDiscoveryRenderer);
  }
};
